import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";
import gql from "graphql-tag";
import UserInfo from "../store/userInfo";

/**
 * https://www.apollographql.com/docs/react/recipes/authentication.html#Header
 */
const httpLink = createHttpLink({
  uri: "/api/web-admin/graphql",
});
const authLink = setContext((_, { headers }) => {
  if (UserInfo.token) {
    return {
      headers: {
        ...headers,
        Authorization: UserInfo.token,
      },
    };
  }

  return headers;
});
/**
 * https://github.com/apollographql/apollo-client/issues/2780#issuecomment-388574352
 * For IE 11 or older
 */
const APOLLO_CLIENT = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

/**
 * https://www.apollographql.com/docs/react/api/apollo-client.html#ApolloClient.query
 */
export const QUERY = async <T>(query: string, variables: Object = {}): Promise<T> => {
  try {
    const response = await APOLLO_CLIENT.query({
      query: gql(query),
      variables,
      fetchPolicy: "no-cache",
    });
    if (process.env.ENVIRONMENT === "DEVELOPMENT") {
      console.log(response.data);
    }
    return response.data;
  } catch (err) {
    const { message } = err;
    const GraphQLErrorTag = "GraphQL error: ";
    if (message.startsWith(GraphQLErrorTag)) {
      throw new Error(message.substr(GraphQLErrorTag.length));
    }

    throw err;
  }
};
/**
 * https://www.apollographql.com/docs/react/api/apollo-client.html#ApolloClient.mutate
 */
export const MUTATE = async <T>(mutate: string, variables: Object = {}): Promise<T> => {
  try {
    const response = await APOLLO_CLIENT.mutate({
      mutation: gql(mutate),
      variables,
      fetchPolicy: "no-cache",
    });
    if (process.env.ENVIRONMENT === "DEVELOPMENT") {
      console.log(response.data);
    }
    return response.data;
  } catch (err) {
    const { message } = err;
    const GraphQLErrorTag = "GraphQL error: ";
    if (message.startsWith(GraphQLErrorTag)) {
      throw new Error(message.substr(GraphQLErrorTag.length));
    }

    throw err;
  }
};
